import { IFriend } from 'redhotpie-shared-lib/interfaces/IFriendUser';
import { ICategory } from '../interfaces/ICommunity';
import { IGroup, IGroupBanner, IJoinSettings } from '../types/clubProfile';
import friends from './friends';
import GroupDetail from './groupDetails';
import Tag from './tag';

export default class Group {
  clubID: number;
  clubName: string;
  clubMemberCount: number;
  isOwner: boolean;
  joinSettings: IJoinSettings;
  banner: IGroupBanner | null;
  friends: {
    totalFriends: number;
    friendProfiles: IFriend;
  } | null;

  constructor() {
    this.clubID = -1;
    this.clubName = '';
    this.clubMemberCount = 0;
    this.isOwner = false;
    this.joinSettings = {
      joinStatus: 'NotJoined',
      canJoinStatus: '',
      privacyType: '',
    };
    this.banner = null;
    this.friends = null;
  }

  static mappingJoinSetting = (data: any) => {
    let _data = {} as IJoinSettings;
    if (data) {
      _data = {
        joinStatus: data.JoinStatus,
        canJoinStatus: data.CanJoinStatus,
        privacyType: data.PrivacyType,
      };
    }
    return _data;
  };
  static mappingBanner = (data: any) => {
    let _data = {} as IGroupBanner;
    if (data) {
      _data = {
        fullUrl: data.FullUrl,
        thumbUrl: data.ThumbUrl,
        width: data.Width,
        height: data.Height,
        approvalState: data.ApprovalState,
      };
    }
    return _data;
  };

  static mappingCategories(_categories: any[]): ICategory[] {
    const categories: ICategory[] = [];
    _categories.forEach(_category => {
      const category: ICategory = {
        isMatch: _category.IsMatch,
        value: _category.Value,
        text: _category.Text,
      };
      categories.push(category); // Added 'as Category' to fix the error
    });
    return categories;
  }

  static mappingObject = (group: any) => {
    let _group: IGroup;
    _group = {
      clubMemberCount: group.ClubMemberCount,
      clubID: group.ClubID,
      id: group.ID,
      clubName: group.ClubName,
      isOwner: group.IsOwner,
      joinSettings: {} as IJoinSettings,
      banner: {} as IGroupBanner,
      friends: {
        friendProfiles: (group?.Friends?.FriendProfile && friends.mappingObject(group.Friends.FriendProfile)) || undefined,
        totalFriends: group?.Friends?.TotalFriends || 0,
      },
      rating: group.Rating,
      totalRateCount: group.TotalRateCount,
      tags: Tag.mappingArray(group.Tags || []),
    };
    if (group.JoinSettings) {
      _group.joinSettings = Group.mappingJoinSetting(group.JoinSettings);
    }
    if (group.Banner) {
      _group.banner = GroupDetail.mappingPhoto(group.Banner);
    }
    if (group.ApprovalState) {
      _group.approvalState = group.ApprovalState;
    }
    return _group;
  };
  static mappingSuggestGroupActivity = (group: any): IGroup => {
    let _group: IGroup;
    _group = {
      clubMemberCount: group.UserCount,
      clubID: group.ID,
      id: group.ID,
      clubName: group.Owner.Username,
      isOwner: false,
      joinSettings: {} as IJoinSettings,
      banner: {} as IGroupBanner,
      friends: {
        friendProfiles: {} as IFriend,
        totalFriends: 0,
      },
      rating: 0,
      totalRateCount: 0,
      tags: [],
      title: group.Title || '',
    };
    if (group.ClubJoinSettings) {
      _group.joinSettings = Group.mappingJoinSetting(group.ClubJoinSettings);
    }
    if (group.Owner.ProfilePhoto) {
      _group.banner = GroupDetail.mappingPhoto(group.Owner.ProfilePhoto);
    }
    if (group.ApprovalState) {
      _group.approvalState = group.ApprovalState;
    }
    return _group;
  };

  static mappingCreateGroupObject = (group: any) => {
    let _group: IGroup;
    _group = {
      clubMemberCount: 1,
      clubID: group.ClubID,
      id: group.ID,
      clubName: group.ProfileDetail.ClubName,
      isOwner: true,
      joinSettings: {} as IJoinSettings,
      banner: {} as IGroupBanner,
      friends: {
        friendProfiles: (group?.Friends?.FriendProfile && friends.mappingObject(group.Friends.FriendProfile)) || undefined,
        totalFriends: group?.Friends?.TotalFriends || 0,
      },
      rating: group.Rating,
      totalRateCount: group.TotalRateCount,
      tags: Tag.mappingArray(group.ProfileDetail.Tags || []),
    };
    if (group.JoinSettings) {
      _group.joinSettings = {
        joinStatus: 'Approved',
        canJoinStatus: 'CanJoin',
        privacyType: group.ProfileDetail.PrivacyType,
      } as IJoinSettings;
    }
    if (group.Banner) {
      _group.banner = GroupDetail.mappingPhoto(group.Banner);
    }
    if (group.ApprovalState) {
      _group.approvalState = group.ApprovalState;
    }
    return _group;
  };
  static mappingObjects = (groups: any[]): IGroup[] => {
    let data: IGroup[];
    data = groups.map(item => Group.mappingObject(item));
    return data;
  };
}
